import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translation files
import trCommon from "./tr/common.json";
import trModule1 from "./tr/module1.json";
import trModule2 from "./tr/module2.json";
import trModule3 from "./tr/module3.json";
import trModule4 from "./tr/module4.json";

import enCommon from "./en/common.json";
import enModule1 from "./en/module1.json";
import enModule2 from "./en/module2.json";
import enModule3 from "./en/module3.json";
import enModule4 from "./en/module4.json";

// Tarayıcı/cihaz dilini al
const getBrowserLanguage = () => {
  const language = navigator.language || navigator.userLanguage;
  return language.startsWith("tr") ? "tr" : "en";
};

// URL'den dil parametresini al
const getURLLanguage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("lang");
};

// Dil önceliğini belirle: URL parametresi > Tarayıcı dili > Varsayılan (en)
const getInitialLanguage = () => {
  const urlLang = getURLLanguage();
  if (urlLang && ["en", "tr"].includes(urlLang.toLowerCase())) {
    return urlLang.toLowerCase();
  }
  return getBrowserLanguage();
};

i18n.use(initReactI18next).init({
  resources: {
    tr: {
      common: trCommon,
      module1: trModule1,
      module2: trModule2,
      module3: trModule3,
      module4: trModule4,
    },
    en: {
      common: enCommon,
      module1: enModule1,
      module2: enModule2,
      module3: enModule3,
      module4: enModule4,
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: "tr",
  interpolation: {
    escapeValue: false,
  },
  ns: ["common", "module1", "module2", "module3", "module4"],
  defaultNS: "common",
});

// URL değişikliğini dinle
window.addEventListener("popstate", () => {
  const newLang = getURLLanguage();
  if (newLang && ["en", "tr"].includes(newLang.toLowerCase())) {
    i18n.changeLanguage(newLang.toLowerCase());
  }
});

export default i18n;
